import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Label,
  Input,
  Breadcrumb,
  BreadcrumbItem,
  Badge,
  Button,
} from "reactstrap";
import IconButton from "@material-ui/core/IconButton";
import toast, { Toaster } from "react-hot-toast";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import { BsCloudDownload, BsPaperclip, BsCheck } from "react-icons/bs";
import { MdAdd, MdEdit } from "react-icons/md";
import { RiDeleteBin6Line } from "react-icons/ri";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import { useParams, Link, useNavigate } from "react-router-dom";

//Componentes
import Loading from "../../components/modales/loadingModal";
// import Button from '@material-ui/core/Button';
import HorizontalLabelPositionBelowStepper from "../../components/stepper/stepper";
import InfoCard from "../../components/cards/cardInfoSeccion";
import ModalCancelacion from "./componentes/modalCancelacion";
import ModalContratacion from "./componentes/modalContratacion";
import ModalDesistimiento from "./componentes/modalDesistimiento";
import ModalFinalizacion from "./componentes/modalFinalizacion";
import ModalSeguridadSocial from "./componentes/modalSeguridadSocial";
import ModalValidacionContrato from "./componentes/modalValidacionContrato";
import DescargarAPEButton from "../../components/buttons/DescargarAPEButton";
import DescargarZIPButton from "../../components/buttons/DescargarZIPButton";
import RetornarButton from "../../components/buttons/RetornarButton";

//Funciones
// import { getItemsList, deleteFile } from '../../utils/azureStorage/upload';

import {
  getFileList,
  getDownloadURLAPI,
  deleteFile,
  getFileZip,
  getFinalFileZip,
} from "../../utils/FirebaseStorage/FirebaseStorage";

//Utils
import { glosarioProceso1 } from "./utils/glosarioContratacion";
import LoadingModalTransparent from "../../components/modales/loadingModalTransparent";
import ModalAdjunto from "./componentes/modalAdjunto";

//API Calls
import { functionsHttpsCallable } from "../../utils/FirebaseStorage/firebase";

//API Calls
const getAPE = functionsHttpsCallable("ape_getSolicitudPorId");
const editarAPE = functionsHttpsCallable("ape_actualizarSolicitudEmpleo");
const exportarAPE = functionsHttpsCallable("ape_exportarSolicitud");
const envioCorreoDevolucion = functionsHttpsCallable(
  "correos_envioCorreoDevolucion"
);

//Toast
const toastSuccess = (msg) => toast.success(msg);
const toastError = (msg) => toast.error(msg);

const mapStateToProps = (state) => ({
  usuarioActivo: state,
});

let VisualizadorAPEContratacion = (props) => {
  const [userData] = useState(JSON.parse(localStorage.getItem("userData")));
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [downloading, setDownloading] = useState(false);
  const [editAttachments, setEditAttachments] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalTransaction, setModalTransaction] = useState(false);
  const [pasoActivo, setPasoActivo] = useState(0);
  const [pasos, setPasos] = useState([]);
  const [selectState, setSelectState] = useState(false);
  const [stateModalAdjunto, setStateModalAdjunto] = useState(false);
  const [stateModalCancelacion, setStateModalCancelacion] = useState(false);
  const [stateModalDesistimiento, setStateModalDesistimiento] = useState(false);
  const [stateModalContratacion, setStateModalContratacion] = useState(false);
  const [stateModalFinalizacion, setStateModalFinalizacion] = useState(false);
  const [stateModalValidacion, setStateModalValidacion] = useState(false);
  const [stateModalSegSocial, setStateModalSegSocial] = useState(false);
  const [updState, setUpdState] = useState(undefined);
  const [userId, setUserId] = useState(true);
  const { id } = useParams();
  const { user, isAuthenticated, isLoading } = useAuth0();

  const listaAux = [
    { id: "auxilioAlimentacion", name: "Auxilio de Alimentación" },
    { id: "auxilioAlimentacionSIS", name: "Auxilio de Alimentación S.I.S." },
    { id: "auxilioLocalizacion", name: "Auxilio de Localización" },
    { id: "auxilioMovilizacion", name: "Auxilio de Movilización" },
    { id: "auxilioMovilizacionSIS", name: "Auxilio de Movilización S.I.S." },
    { id: "bonificacionCIS", name: "Bonificación C.I.S." },
    { id: "bonificacionSIS", name: "Bonificación S.I.S." },
    { id: "primaElSauceMansovar", name: "Prima El Sauce Mansovar" },
    { id: "primaHabitacionalCIS", name: "Prima Habitacional C.I.S." },
    {
      id: "primaAlimentacionYAlojamientoMasaro",
      name: "Prima Alimentacion y Alojamiento Mansaro",
    },
    { id: "auxilioGaitanSIS", name: "Auxilio Económico Gaitán S.I.S. Mensual" },
    {
      id: "auxilioConvencionalECP",
      name: "Auxilio Transporte Convecional ECP",
    },
    {
      id: "subsidioConvencionalHabitacion",
      name: "Subsidio Convencional Habitación",
    },
    { id: "auxilioTransporteConv", name: "Auxilio Transporte Conv." },
    {
      id: "bonificacionBeneficioBienestar",
      name: "Bonificación Beneficio de Bienestar",
    },
    { id: "auxCaminanteNoSalarial", name: "AUXILIO DE CAMINANTE NO SALARIAL" },
    { id: "auxNoSalarialCasino", name: "AUXILIO NO SALARIAL CASINO" },
    {
      id: "auxProduccionYCampoSIS",
      name: "AUXILIO DE PRODUCCION Y DE CAMPO S.I.S",
    },
    { id: "auxAlimentacionDiario", name: "AUXILIO ALIMENTACION DIARIO S.I.S" },
    { id: "auxMovilizacionDiario", name: "AUXILIO MOVILIZACION DIARIO S.I.S" },
    { id: "auxLocalizacionDiario", name: "AUXILIO LOCALIZACION DIARIO S.I.S" },
    { id: "auxLoncheSIS", name: "AUXILIO POR LONCHE S.I.S" },
    {
      id: "auxEspecialTransporteSIS",
      name: "AUXILIO ESPECIAL DE TRANSPORTE SIS",
    },
    {
      id: "auxEspecialAlimentacionSIS",
      name: "AUXILIO ESPECIAL DE ALIMENTACION SIS",
    },
    { id: "auxEspecialLejanias", name: "AUXILIO ESPECIAL DE LEJANIAS" },
    {
      id: "auxNoSalarialBloqueMatambo",
      name: "AUXILIO NO SALARIAL BLOQUE MATAMBO",
    },
    {
      id: "auxNoSalarialBloqueCampoRico",
      name: "AUXILIO NO SALARIAL BLOQUE CAMPO RICO",
    },
    { id: "auxViaticosTSA", name: "AUXILIO POR VIATICOS TSA" },
    {
      id: "auxTrabajoRemotoUtipecSIS",
      name: "AUXILIO TRABAJO REMOTO UTIPEC SIS",
    },
    {
      id: "auxNoSalarialBloqueMaranta",
      name: "AUXILIO NO SALARIAL BLOQUE MARANTA",
    },
    {
      id: "auxAlimentacionDiarioCIS",
      name: "AUXILIO ALIMENTACION DIARIO C.I.S",
    },
    { id: "auxViaticosEMO", name: "AUXILIO POR VIATICOS EMO" },
    {
      id: "auxEconomicoObrasMetalMecanica",
      name: "AUXILIO ECONOMICO OBRAS METALMECANICA",
    },
    { id: "auxTransporteDiarioSIS", name: "AUXILIO DE TRANSPORTE DIARIO SIS" },
    { id: "bonificacionCISDiario", name: "Bonificación C.I.S. DIARIO" },
    { id: "bonificacionSISDiario", name: "Bonificación S.I.S. DIARIO" },
  ];

  useEffect(() => {
    document.title = "Detalle APE";
    if (isAuthenticated && !isLoading) {
      setUserId(user["http://localhost:3000/username"]);
    }
    async function getData() {
      await getInformacionAdjuntos(id);
      await getInformacionSolicitud();
    }
    getData();
  }, []);

  useEffect(() => {
    getPasosProceso();
    getPasoActivo();
  }, [data]);

  useEffect(() => {
    async function change() {
      if (updState !== undefined) {
        await getInformacionAdjuntos(id);
        await StateUpdateButton();
      }
    }
    change();
  }, [updState]);

  useEffect(() => {
    async function change() {
      if (updState !== undefined) {
        await getInformacionAdjuntos(id);
        await StateUpdateButton();
      }
    }
    change();
  }, [updState]);

  const cancelarSolicitud = () => {
    let newData = { ...data };
    newData.estadoAPE = "CANCELADA";
    setData(newData);
  };

  const downloadFile = async (filename) => {
    try {
      let downloadLink = await getDownloadURLAPI(`APEFiles/${id}`, filename);
      let downloadWindow = window.open(
        downloadLink,
        "_blank",
        "noopener,noreferrer"
      );
      if (downloadWindow) downloadWindow.opener = null;
      toastSuccess("Descarga Exitosa!");
    } catch (e) {
      toastError("Hubo un problema con la descarga!");
      console.log("error", e);
    }
  };

  const downloadZip = async () => {
    setModalTransaction(true);
    try {
      let downloadLink = await getFinalFileZip(`APEFiles/${id}`, userData);
      setModalTransaction(false);
      toastSuccess("Descarga Exitosa!");
    } catch (e) {
      setModalTransaction(false);
      toastError("Hubo un problema con la descarga!");
      console.log("error", e);
    }
  };

  const updateDataApeLocal = (newData) => {
    const tempObj = data;
    Object.keys(newData).forEach((key) => {
      tempObj[key] = newData[key];
    });
    setData({ ...tempObj });
  };

  const downloadSolicitud = async () => {
    setModalTransaction(true);
    let body = {
      solicitudId: id,
    };
    try {
      setDownloading(true);
      let downloadLink = await exportarAPE(body);
      let downloadWindow = window.open(
        downloadLink.data.data,
        "_blank",
        "noopener,noreferrer"
      );
      if (downloadWindow) downloadWindow.opener = null;
      setModalTransaction(false);
      setDownloading(false);
      toastSuccess("Descarga Exitosa!");
    } catch (e) {
      setModalTransaction(false);
      toastError("Hubo un problema con la descarga!");
      console.log("error", e);
    }
  };

  const getActiveStepAge = (updateDate) => {
    const now = new Date(Date.now());
    const age =
      (now.getTime() - new Date(updateDate).getTime()) / (24 * 60 * 60 * 1000);
    return age ?? 0;
  };

  const getInformacionAdjuntos = async (id) => {
    let filesList = await getFileList(`APEFiles/${id}/`);
    setFileList(filesList);
  };

  const getInformacionSolicitud = async () => {
    let body = {
      solicitudId: id,
      cod_empr: userData.codigoEmpresa ?? 537,
    };
    const APEInfo = await getAPE(body);
    if (APEInfo.data.status !== "CONSULTA_EXITOSA") {
      toastError("Hubo un problema con la solicitud");
      navigate("/home/proceso-seleccion");
    }
    const tempData = APEInfo.data.data;
    tempData["salario"] = APEInfo.data.data.salario;
    setData(tempData);
    setLoading(false);
  };

  const getPasoActivo = () => {
    let pasoActivo = 0;
    Object.keys(glosarioProceso1).forEach((key, index) => {
      if (glosarioProceso1[key].id === data.estadoAPE) {
        pasoActivo = {
          index: index,
          ...glosarioProceso1[Object.keys(glosarioProceso1)[index]],
        };
      }
    });
    setPasoActivo(pasoActivo);
    return pasoActivo;
  };

  const getPasosProceso = () => {
    let pasosTemp = [];
    Object.keys(glosarioProceso1).forEach((key) => {
      pasosTemp.push(glosarioProceso1[key].name);
    });
    setPasos(pasosTemp);
  };

  const handleDelete = async (file) => {
    setModalTransaction(true);
    let tempFileList = fileList;
    let fileIndex;
    try {
      setLoading(true);
      fileIndex = fileList.indexOf(file);
      tempFileList.splice(fileIndex, 1);
      await deleteFile(`APEFiles/${id}`, file.fileName);
      setFileList(tempFileList);
      setLoading(false);
      toastSuccess("Archivo Eliminado!");
    } catch (error) {
      toastError("Ocurrio un error al eliminar el archivo");
    }
    setModalTransaction(false);
  };

  const handleRetornarFechaIngreso = async () => {
    try {
      Swal.fire({
        title: "¿Desea regresar el proceso a confirmación fecha de ingreso?",
        html: `El proceso regresará al administrador de contrato ${
          data.flujo.nombreConfirmacionFecha
            ? data.flujo.nombreConfirmacionFecha
            : data.flujo.nombrePrimerContratador
        }`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "No, regresar",
        cancelButtonText: "Sí, confirmar!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          setModalTransaction(true);
          const body = {
            cod_soli: id,
            cod_empr: userData.codigoEmpresa,
            data: {
              cmp_stat: "CONFIRMACION_FECHA_CONTRATACION",
              cod_actu: data.flujo.cedulaConfirmacionFecha
                ? data.flujo.cedulaConfirmacionFecha
                : data.flujo.cedulaPrimerAprobador,
            },
          };
          await editarAPE(body);
          navigate("/home/proceso-contratacion");
          setModalTransaction(false);
        } else if (result.isDismissed) {
          setModalTransaction(false);
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleDevolver = async (msg) => {
    setModalTransaction(true);
    const body = {
      cod_soli: id,
      cod_empr: userData.codigoEmpresa,
      data: {
        cmp_stat: "RECLUTADOR",
        cod_actu: data.flujo.cedulaReclutador,
      },
    };
    const correoData = {
      codigoAPE: id,
      enviarA: [
        data.flujo.emailReclutador,
        "profesional.reclutamiento@confipetrol.com",
      ],
      comentarios: msg,
    };
    await editarAPE(body);
    await envioCorreoDevolucion(correoData);
    navigate("/home/proceso-contratacion");
    setModalTransaction(false);
  };

  const FileUploader = () => {
    return (
      <div className={"FileUploader-style"}>
        <IconButton
          aria-label="Add"
          onClick={() => {
            setEditAttachments(!editAttachments);
          }}
        >
          <MdEdit size={24} />
        </IconButton>
      </div>
    );
  };

  const updateStateInDb = async (dataExt) => {
    setModalTransaction(true);
    let tempData = { ...data };
    if (updState === "SEGURIDAD_SOCIAL") {
      if (dataExt)
        dataExt.ced_cand
          ? (tempData.cedulaCandidato = parseInt(dataExt.cedulaCandidato))
          : (tempData.cedulaCandidato = 0);
    }
    tempData.estadoAPE = dataExt.updState;
    try {
      await updateState(dataExt);
      setData(tempData);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
    setModalTransaction(false);
  };

  const getResultadoEvaluacion = () => {
    const result =
      (data.calificacionEntrevista ?? 0) * 0.3 +
      (data.calificacionPruebaTecnica ?? 0) * 0.4 +
      (data.calificacionHSEQ ?? 0) * 0.15 +
      (data.calificacionHabilidades ?? 0) * 0.15;
    return result;
  };

  const renderBadgeAdjuntos = () => {
    return fileList.map((file, index) => {
      if (editAttachments) {
        return (
          <Button
            key={`attachment_button_edit_${index}`}
            className="badge-attached-file"
            outline
            onClick={() => {
              handleDelete(file);
            }}
            color="danger"
          >
            {file.fileName}
            <RiDeleteBin6Line size={16} />
          </Button>
        );
      } else {
        return (
          <Button
            key={`attachment_button_${index}`}
            className="badge-attached-file"
            outline
            onClick={() => {
              downloadFile(file.fileName);
            }}
            color="primary"
          >
            {file.fileName}
            <BsPaperclip size={16} />
          </Button>
        );
      }
    });
  };

  const renderConfirmacionMatrizI = async (newState) => {
    let body = {
      cod_soli: id,
      cod_empr: userData.codigoEmpresa,
      data: {
        cmp_stat: "CONTRATACION_2",
      },
    };
    try {
      Swal.fire({
        title: "¿Desea confirmar Validación de Documentos?",
        input: "text",
        inputAttributes: {
          autocapitalize: "off",
        },
        html:
          "El proceso pasará a la etapa de contratacion con los archivos adjuntos existentes actualmente." +
          "<p>En caso de regresar el proceso escriba aca las razones:</p>",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "No, regresar",
        cancelButtonText: "Sí, confirmar!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          await handleDevolver(result.value);
        } else if (result.isDismissed) {
          try {
            await editarAPE(body);
          } catch (error) {
            console.log(error);
          }
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const StateUpdateButton = () => {
    const handleClick = () =>
      setSelectState((prevSelectState) => !prevSelectState);
    const handleClose = () => setSelectState(false);
    const handleOpen = () => setSelectState(true);
    const handleChange = async (newState) => {
      setUpdState(newState);
      if (newState === "FINALIZADO") toggleModalFinalizacion();
      else if (newState === "CONTRATACION_2") toggleModalContratacion();
      else if (newState === "CONTRATACION_3") toggleModalValidacion();
      else if (newState === "SEGURIDAD_SOCIAL") toggleModalSeguridadSocial();
      else if (newState === "VERIFICACION_DOCUMENTAL")
        renderConfirmacionMatrizI(newState);
      else toggleModalAdjunto();
    };
    const arrEstados = [
      "INGRESO_KACTUS",
      "REPORTE_NOMINA",
      "FINALIZADO",
      "END",
    ];

    return (
      <div className={"FileUploader-style"}>
        {selectState ? (
          <FormControl>
            <Select
              labelId="demo-controlled-open-select-label"
              id="demo-controlled-open-select"
              open={selectState}
              onClose={handleClose}
              onOpen={handleOpen}
              onChange={(e) => handleChange(e.target.value)}
            >
              {Object.keys(glosarioProceso1).map((key, index) => {
                if (
                  !glosarioProceso1[key].restricted ||
                  (glosarioProceso1[key].restricted &&
                    arrEstados.includes(data.estadoAPE))
                )
                  return (
                    <MenuItem
                      key={`state_item_${index}`}
                      value={glosarioProceso1[key].id}
                    >
                      {glosarioProceso1[key].name}
                    </MenuItem>
                  );
              })}
            </Select>
          </FormControl>
        ) : null}
        <IconButton
          aria-label="Add"
          onClick={() => {
            handleClick();
          }}
        >
          <MdEdit size={24} />
        </IconButton>
      </div>
    );
  };

  const toggleModalAdjunto = () =>
    setStateModalAdjunto((prevStateModalAdjutno) => !prevStateModalAdjutno);
  const toggleModalDesistimiento = () =>
    setStateModalDesistimiento(
      (prevStateModalDesistimiento) => !prevStateModalDesistimiento
    );
  const toggleModalTransaction = () =>
    setModalTransaction(
      (prevStateModalTransaction) => !prevStateModalTransaction
    );
  const toggleModalCancelacion = () =>
    setStateModalCancelacion(
      (prevStateModalCancelacion) => !prevStateModalCancelacion
    );
  const toggleModalContratacion = () =>
    setStateModalContratacion(
      (prevStateModalContratacion) => !prevStateModalContratacion
    );
  const toggleModalFinalizacion = () =>
    setStateModalFinalizacion(
      (prevStateModalFinalizacion) => !prevStateModalFinalizacion
    );
  const toggleModalValidacion = () =>
    setStateModalValidacion(
      (prevStateModalValidacion) => !prevStateModalValidacion
    );
  const toggleModalSeguridadSocial = () =>
    setStateModalSegSocial((prevStateModSeguridad) => !prevStateModSeguridad);

  const updateState = async (dataExt) => {
    let body = {
      cod_soli: id,
      cod_empr: userData.codigoEmpresa,
      data: {
        cmp_stat: dataExt.updState,
        cod_actu: userId,
        fec_cont: new Date(data.fechaContratacion._seconds).toISOString(),
        ced_cand:
          dataExt !== undefined
            ? dataExt.cedulaCandidato && dataExt.cedulaCandidato !== undefined
              ? parseInt(dataExt.cedulaCandidato)
              : data.cedulaCandidato
            : data.cedulaCandidato ?? 0,
      },
    };
    await editarAPE(body);
  };

  if (loading) {
    return (
      <div className={"loading-area"}>
        {" "}
        <Loading />{" "}
      </div>
    );
  } else {
    return (
      <div>
        <LoadingModalTransparent isOpen={modalTransaction} />
        <Toaster />
        <ModalCancelacion
          toastSuccess={(e) => {
            toastSuccess(e);
          }}
          toastError={(e) => {
            toastError(e);
          }}
          toggle={toggleModalCancelacion}
          toggleTransaction={toggleModalTransaction}
          modal={stateModalCancelacion}
          action={cancelarSolicitud}
          data={data}
        />
        {updState !== undefined ? (
          <ModalFinalizacion
            toastSuccess={(e) => {
              toastSuccess(e);
            }}
            toastError={(e) => {
              toastError(e);
            }}
            toggle={toggleModalFinalizacion}
            modal={stateModalFinalizacion}
            fileList={fileList}
            data={data}
            setLoading={(e) => setLoading(e)}
            currentState={data.estadoAPE}
            newState={updState}
            id={id}
            updateStateInDb={(e) => {
              updateStateInDb(e);
            }}
          />
        ) : null}
        {updState !== undefined ? (
          <ModalContratacion
            toastSuccess={(e) => {
              toastSuccess(e);
            }}
            toastError={(e) => {
              toastError(e);
            }}
            toggle={toggleModalContratacion}
            loadingModal={toggleModalTransaction}
            data={data}
            modal={stateModalContratacion}
            fileList={fileList}
            setLoading={(e) => setLoading(e)}
            currentState={data.estadoAPE}
            newState={updState}
            id={id}
            updateStateInDb={(e) => {
              updateStateInDb(e);
            }}
          />
        ) : null}
        {updState !== undefined ? (
          <ModalAdjunto
            toastSuccess={(e) => {
              toastSuccess(e);
            }}
            toastError={(e) => {
              toastError(e);
            }}
            toggle={toggleModalAdjunto}
            modal={stateModalAdjunto}
            fileList={fileList}
            setFileList={(e) => {
              setFileList(e);
            }}
            setLoading={(e) => setLoading(e)}
            currentState={data.estadoAPE}
            newState={updState}
            id={id}
            updateStateInDb={(e) => {
              updateStateInDb(e);
            }}
          />
        ) : null}
        {updState !== undefined ? (
          <ModalValidacionContrato
            toastSuccess={(e) => {
              toastSuccess(e);
            }}
            toastError={(e) => {
              toastError(e);
            }}
            toggle={toggleModalValidacion}
            modal={stateModalValidacion}
            fileList={fileList}
            setFileList={(e) => {
              setFileList(e);
            }}
            setLoading={(e) => setLoading(e)}
            currentState={data.estadoAPE}
            data={data}
            newState={updState}
            id={id}
            updateAPE={(e) => {
              updateDataApeLocal(e);
            }}
          />
        ) : null}
        <ModalDesistimiento
          toggle={toggleModalDesistimiento}
          modal={stateModalDesistimiento}
          setLoading={(e) => setLoading(e)}
          id={id}
          data={data}
        />
        {updState !== undefined ? (
          <ModalSeguridadSocial
            toastSuccess={(e) => {
              toastSuccess(e);
            }}
            toastError={(e) => {
              toastError(e);
            }}
            toggle={toggleModalSeguridadSocial}
            modal={stateModalSegSocial}
            data={data}
            fileList={fileList}
            setFileList={(e) => {
              setFileList(e);
            }}
            setLoading={(e) => setLoading(e)}
            currentState={data.estadoAPE}
            newState={updState}
            id={id}
            updateAPE={(e) => {
              updateDataApeLocal(e);
            }}
          />
        ) : null}
        <Breadcrumb>
          <BreadcrumbItem active>
            <Link to={"/home/proceso-contratacion"}>Solicitudes</Link>
          </BreadcrumbItem>
          <BreadcrumbItem active>Solicitud N° {id}</BreadcrumbItem>
        </Breadcrumb>
        <div className="breadcum-display-content-2">
          <RetornarButton
            onClick={() => {
              handleRetornarFechaIngreso();
            }}
          />
          <DescargarAPEButton
            onClick={() => {
              downloadSolicitud();
            }}
          />
          <DescargarZIPButton
            onClick={() => {
              downloadZip();
            }}
          />
        </div>
        <div>
          <InfoCard button={<StateUpdateButton />} title={"Estado Proceso"}>
            <HorizontalLabelPositionBelowStepper
              activeStepAge={getActiveStepAge(
                data.fechaActualizacion ??
                  new Date(Date.now).toISOString.split("T")
              )}
              steps={pasos}
              activeStep={pasoActivo.index}
              pasoActivo={pasoActivo}
            />
            {/* <div className={'label-left-time'}><Label>{getHoursLeftRecl()}</Label></div>
                    <div className={'label-left-time'}><Label>{getHoursLeftEstado()}</Label></div> */}
          </InfoCard>
        </div>
        <br />
        <InfoCard title={"1. Tipo de Vacante"}>
          <Row>
            <Col lg="2" md="6" xs="12">
              <Label for="exampleSelect">Tipo de Vacante</Label>
              <Input
                type="text"
                name="text"
                id="inputVacante"
                readOnly
                defaultValue={data.tipoVacante}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Cargo</Label>
              <Input
                type="text"
                name="text"
                id="inputCargo"
                readOnly
                defaultValue={data.codigoCargo}
              />
            </Col>
            <Col lg="2" md="6" xs="12">
              <Label for="exampleSelect">Cantidad de Vacantes</Label>
              <Input
                type="text"
                name="text"
                id="inputProceso"
                readOnly
                defaultValue={data.numeroPlazas}
              />
            </Col>
            <Col lg="2" md="6" xs="12">
              <Label for="exampleSelect">Proceso/Area</Label>
              <Input
                type="text"
                name="text"
                id="inputProceso"
                readOnly
                defaultValue={data.proceso}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Trabajador a Reemplazar</Label>
              <Input
                type="text"
                name="text"
                id="inputTrabajadorReemp"
                readOnly
                defaultValue={data.trabajadorReemplazar}
              />
            </Col>
          </Row>
        </InfoCard>
        <br />
        <InfoCard title={"2. Origen del Cargo"}>
          <Row xs="2">
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Contractual/No Contractual</Label>
              <Input
                type="text"
                name="text"
                id="inputContractual"
                readOnly
                defaultValue={data.tipoContractual}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Cliente Comercial</Label>
              <Input
                type="text"
                name="text"
                id="inputClienteCom"
                readOnly
                defaultValue={data.clienteComercial}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">N° de Contrato</Label>
              <Input
                type="text"
                name="text"
                id="inputNumContrato"
                readOnly
                defaultValue={data.numeroContrato}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Ítem de Cobro</Label>
              <Input
                type="text"
                name="text"
                id="inputItemCobro"
                readOnly
                defaultValue={data.itemCobro}
              />{" "}
              {/* confirmar */}
            </Col>
          </Row>
          <Row xs="2">
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Código ATA</Label>
              <Input
                type="text"
                name="text"
                id="inputCodigoATA"
                readOnly
                defaultValue={data.codigoATA}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Centro de Costos</Label>
              <Input
                type="text"
                name="text"
                id="inputCentroCostos"
                readOnly
                defaultValue={data.centroCosto}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">*PEP</Label>
              <Input
                type="text"
                name="text"
                id="inputPep"
                readOnly
                defaultValue={data.PEP}
              />
            </Col>
          </Row>
        </InfoCard>
        <br />
        <InfoCard title={"3. Condiciones Laborales"}>
          <Row xs="2">
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Campo</Label>
              <Input
                type="text"
                name="text"
                id="inputCampo"
                readOnly
                defaultValue={data.campo}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Especialidad</Label>
              <Input
                type="text"
                name="text"
                id="inputEspecialidad"
                readOnly
                defaultValue={data.especialidad}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Duración del Contrato</Label>
              <Input
                type="text"
                name="text"
                id="inputDuracionContrato"
                readOnly
                defaultValue={data.duracionContrato}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Tipo de Contrato</Label>
              <Input
                type="text"
                name="text"
                id="inputTipoContrato"
                readOnly
                defaultValue={data.tipoContrato}
              />
            </Col>
          </Row>
          <Row xs="2">
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Nómina/Planilla</Label>
              <Input
                type="text"
                name="text"
                id="inputNomina"
                readOnly
                defaultValue={data.tipoNomina}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Tipo de Salario</Label>
              <Input
                type="text"
                name="text"
                id="inputTipoSalario"
                readOnly
                defaultValue={data.tipoSalario}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Salario Básico</Label>
              <Input
                type="text"
                name="text"
                id="inputSalario"
                readOnly
                defaultValue={
                  data.salario ? parseInt(data.salario).toLocaleString() : "$ 0"
                }
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Jefe Inmediato</Label>
              <Input
                type="text"
                name="text"
                id="inputJefe"
                readOnly
                defaultValue={data.jefeInmediato}
              />
            </Col>
          </Row>
          <Row xs="2">
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Funciones de Conductor</Label>
              <Input
                type="text"
                name="text"
                id="inputFuncionesConductor"
                readOnly
                defaultValue={data.funcionesConductor}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Turno/Régimen de Trabajo</Label>
              <Input
                type="text"
                name="text"
                id="inputTurno"
                readOnly
                defaultValue={data.turno}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Auxilio de Alimentación</Label>
              <Input
                type="text"
                name="text"
                id="inputAuxAlim"
                readOnly
                defaultValue={data.auxilioAlimentacion}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Auxilio de Localización</Label>
              <Input
                type="text"
                name="text"
                id="inputLoc"
                readOnly
                defaultValue={data.auxilioLocalizacion}
              />
            </Col>
          </Row>
          <Row xs="2">
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Auxilio de Movilización</Label>
              <Input
                type="text"
                name="text"
                id="inputAuxMov"
                readOnly
                defaultValue={data.auxilioMovilidad}
              />
            </Col>
          </Row>
          <Row xs="2">
            <Col xs="12">
              <Label for="exampleSelect">Otros</Label>
              <Input
                type="textarea"
                name="text"
                id="inputTurno"
                readOnly
                defaultValue={data.otros}
              />
            </Col>
          </Row>
          <Row xs="2">
            <Col xs="12">
              <Label for="exampleSelect">Observaciones APE</Label>
              <Input
                type="textarea"
                name="text"
                id="inputTurno"
                readOnly
                defaultValue={data.observaciones}
              />
            </Col>
          </Row>
          <Row xs="2">
            <Col xs="12">
              <Label for="exampleSelect">Observaciones Reclutamiento</Label>
              <Input
                type="textarea"
                name="text"
                id="inputTurno"
                readOnly
                defaultValue={data.observacionesReclutamiento}
              />
            </Col>
          </Row>
        </InfoCard>
        <br />
        <InfoCard title={"3.1 Auxilios"}>
          <Row xs="2">
            {listaAux.map((aux) => {
              if (data[aux.id] !== undefined && data[aux.id] !== null) {
                return (
                  <Col lg="3" md="6" xs="12">
                    <Label for="exampleSelect">{aux.name}</Label>
                    <Input
                      type="text"
                      name="text"
                      id="inputSalario"
                      readOnly
                      defaultValue={data[aux.id] ? data[aux.id] : "$ 0"}
                    />
                  </Col>
                );
              }
            })}
          </Row>
        </InfoCard>
        <br />
        <InfoCard title={"4. Calificación Pruebas y Entrevista"}>
          <Row xs="2">
            <Col lg="2" md="6" xs="12">
              <Label for="exampleSelect">Prueba HSEQ</Label>
              <Input
                type="text"
                name="text"
                id="inputPruebaHSEQ"
                readOnly
                defaultValue={data.calificacionHSEQ}
              />
            </Col>
            <Col lg="2" md="6" xs="12">
              <Label for="exampleSelect">Prueba Técnica</Label>
              <Input
                type="text"
                name="text"
                id="inputPruebaTecnica"
                readOnly
                defaultValue={data.calificacionPruebaTecnica}
              />
            </Col>
            <Col lg="2" md="6" xs="12">
              <Label for="exampleSelect">Prueba Habilidades Blandas</Label>
              <Input
                type="text"
                name="text"
                id="inputPruebaHB"
                readOnly
                defaultValue={data.calificacionHabilidades}
              />
            </Col>
            <Col lg="2" md="6" xs="12">
              <Label for="exampleSelect">Entrevista</Label>
              <Input
                type="text"
                name="text"
                id="inputPruebaEntrevista"
                readOnly
                defaultValue={data.calificacionEntrevista}
              />{" "}
              {/* confirmar */}
            </Col>
            <Col lg="4" md="6" xs="12">
              <Label for="exampleSelect">Resultado</Label>
              <Input
                type="text"
                name="text"
                id="inputResultados"
                readOnly
                defaultValue={getResultadoEvaluacion()}
              />{" "}
              {/* confirmar */}
            </Col>
          </Row>
        </InfoCard>
        <br />
        <InfoCard title={"5. Recursos"}>
          <Row xs="12">
            {data.recursos !== null &&
            data.recursos !== undefined &&
            data.recursos.length > 0 ? (
              data.recursos.map((recurso, index) => {
                return (
                  <Button
                    className="badge-attached-file"
                    key={`key_recurso_btn_${index}`}
                    outline
                    disabled
                    color="success"
                  >
                    {recurso}
                    <BsCheck size={16} />
                  </Button>
                );
              })
            ) : (
              <div className="ape-list-nodata-text">
                <p>No hay recursos asignados</p>
              </div>
            )}
          </Row>
        </InfoCard>
        <br />
        <InfoCard title={"Archivos Adjuntos"} button={<FileUploader />}>
          <Row xs="2">{renderBadgeAdjuntos()}</Row>
        </InfoCard>
        <br />
        <div className={"breadcum-header-buttons"}>
          <div className={"button-bar-container"}>
            <div className={"button-bar-button"}>
              <Button
                variant="contained"
                color="warning"
                onClick={() => toggleModalDesistimiento()}
                disabled={false}
              >
                Desiste del proceso
              </Button>
            </div>
            <div className={"button-bar-button"}>
              <Button
                variant="contained"
                color="danger"
                onClick={() => toggleModalCancelacion()}
                disabled={false}
              >
                Cancelar
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default withAuthenticationRequired(
  connect(mapStateToProps)(VisualizadorAPEContratacion),
  {
    onRedirecting: () => <Loading />,
  }
);
